import e, { useEffect as t, useState as n, useRef as r } from "react";
import i from "@babel/runtime/helpers/taggedTemplateLiteral";
import o from "styled-components";
import a from "@babel/runtime/helpers/extends";
import l from "@babel/runtime/helpers/slicedToArray";
import c from "@babel/runtime/helpers/toConsumableArray";
import { animated as s, useSpring as u, to as f, useSprings as p, config as m, useTransition as g } from "@react-spring/web";
import { useGesture as d } from "react-use-gesture";
import v from "@babel/runtime/helpers/defineProperty";
import h from "@babel/runtime/helpers/objectWithoutProperties";
import y from "@babel/runtime/helpers/classCallCheck";
import b from "@babel/runtime/helpers/createClass";
import w from "@babel/runtime/helpers/assertThisInitialized";
import O from "@babel/runtime/helpers/inherits";
import x from "@babel/runtime/helpers/possibleConstructorReturn";
import C from "@babel/runtime/helpers/getPrototypeOf";
import P from "react-dom";

var E,
    k = function k(e) {
  var t,
      n = e.imageRef,
      r = e.scale,
      i = e.pinchDelta,
      o = l(e.touchOrigin, 2),
      a = o[0],
      c = o[1],
      s = l(e.currentTranslate, 2),
      u = s[0],
      f = s[1];
  if (null == n || !n.current) return [0, 0];
  var p = null === (t = n.current) || void 0 === t ? void 0 : t.getBoundingClientRect(),
      m = p.height,
      g = p.left,
      d = p.top;
  return [-((a - g - p.width / 2) / r) * i + u, -((c - d - m / 2) / r) * i + f];
},
    D = function D(e) {
  var t;
  if (!e.current) return !1;
  var n = null === (t = e.current) || void 0 === t ? void 0 : t.getBoundingClientRect(),
      r = n.bottom,
      i = n.left,
      o = n.right,
      a = n.top,
      l = window,
      c = l.innerHeight,
      s = l.innerWidth;
  return i > .5 * s || a > .5 * c || o < .5 * s || r < .5 * c;
},
    T = ["style"];

function j(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function I(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? j(Object(n), !0).forEach(function (t) {
      v(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : j(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var N = {
  pinching: !1,
  scale: 1,
  translateX: 0,
  translateY: 0
},
    L = function L(i) {
  var o,
      c = i.imgProps,
      s = c.style,
      p = h(c, T),
      m = i.isCurrentImage,
      g = i.pagerHeight,
      y = i.pagerIsDragging,
      b = i.setDisableDrag,
      w = i.singleClickToZoom,
      O = n(!1),
      x = l(O, 2),
      C = x[0],
      P = x[1],
      E = r(null),
      j = u(function () {
    return I(I({}, N), {}, {
      onChange: function onChange(e, t) {
        (e.value.scale < 1 || !e.value.pinching) && t.start(N), e.value.scale > 1 && D(E) && t.start(N);
      },
      onRest: function onRest(e, t) {
        1 === e.value.scale && (t.start(N), b(!1));
      }
    });
  }),
      L = l(j, 2),
      R = L[0],
      X = R.scale,
      W = R.translateX,
      Y = R.translateY,
      H = L[1];
  return t(function () {
    m || 1 === X.get() || H.start(N);
  }, [m, X, H]), d({
    onDrag: function onDrag(e) {
      var t = l(e.movement, 2),
          n = t[0],
          r = t[1],
          i = e.pinching,
          o = e.cancel,
          a = e.first,
          c = e.memo,
          s = void 0 === c ? {
        initialTranslateX: 0,
        initialTranslateY: 0
      } : c,
          u = e.touches,
          f = e.tap;
      if (!(y || 1 === X.get() || f || (n && r && !C && P(!0), u > 1 || i || X.get() <= 1))) return X.get() > 1 && D(E) ? void o() : a ? {
        initialTranslateX: W.get(),
        initialTranslateY: Y.get()
      } : (H.start({
        translateX: s.initialTranslateX + n,
        translateY: s.initialTranslateY + r
      }), s);
    },
    onDragEnd: function onDragEnd(e) {
      void 0 !== e.memo && setTimeout(function () {
        return P(!1);
      }, 100);
    },
    onPinch: function onPinch(e) {
      var t = l(e.movement, 1)[0],
          n = l(e.origin, 2),
          r = n[0],
          i = n[1],
          o = e.event,
          a = e.ctrlKey,
          c = e.last,
          s = e.cancel;
      if (!y) if (b(!0), t && !C && P(!0), c) s();else {
        var u = a ? 1e3 : 250,
            f = X.get() + t / u,
            p = f - X.get(),
            m = [r, i];
        "clientX" in o && "clientY" in o && a && (m = [o.clientX, o.clientY]);
        var g = k({
          currentTranslate: [W.get(), Y.get()],
          imageRef: E,
          pinchDelta: p,
          scale: X.get(),
          touchOrigin: m
        }),
            d = l(g, 2),
            v = d[0],
            h = d[1];
        f < .5 ? H.start({
          pinching: !0,
          scale: .5
        }) : f > 3 ? H.start({
          pinching: !0,
          scale: 3
        }) : H.start({
          pinching: !0,
          scale: f,
          translateX: v,
          translateY: h
        });
      }
    },
    onPinchEnd: function onPinchEnd() {
      y || (X.get() > 1 ? b(!0) : H.start(N), setTimeout(function () {
        return P(!1);
      }, 100));
    }
  }, {
    domTarget: E,
    drag: {
      filterTaps: !0
    },
    eventOptions: {
      passive: !1
    }
  }), function (e) {
    var n = e.ref,
        r = e.latency,
        i = void 0 === r ? 300 : r,
        o = e.onSingleClick,
        a = void 0 === o ? function () {
      return null;
    } : o,
        l = e.onDoubleClick,
        c = void 0 === l ? function () {
      return null;
    } : l;
    t(function () {
      var e,
          t = n.current,
          r = 0,
          o = function o(t) {
        r += 1, e = setTimeout(function () {
          1 === r ? a(t) : 2 === r && c(t), r = 0;
        }, i);
      };

      return null == t || t.addEventListener("click", o), function () {
        null == t || t.removeEventListener("click", o), e && clearTimeout(e);
      };
    });
  }((v(o = {}, w ? "onSingleClick" : "onDoubleClick", function (e) {
    if (y || C) e.stopPropagation();else if (1 === X.get()) {
      var t = e.clientX,
          n = e.clientY,
          r = X.get() + 1,
          i = r - X.get(),
          o = k({
        currentTranslate: [W.get(), Y.get()],
        imageRef: E,
        pinchDelta: i,
        scale: X.get(),
        touchOrigin: [t, n]
      }),
          a = l(o, 2),
          c = a[0],
          s = a[1];
      b(!0), H.start({
        pinching: !0,
        scale: r,
        translateX: c,
        translateY: s
      });
    } else H.start(N);
  }), v(o, "latency", w ? 0 : 200), v(o, "ref", E), o)), e.createElement(B, a({
    className: "lightbox-image",
    draggable: "false",
    onClick: function onClick(e) {
      e.stopPropagation(), e.nativeEvent.stopImmediatePropagation();
    },
    onDragStart: function onDragStart(e) {
      e.preventDefault();
    },
    ref: E,
    style: I(I({}, s), {}, {
      maxHeight: g,
      transform: f([X, W, Y], function (e, t, n) {
        return "translate(".concat(t, "px, ").concat(n, "px) scale(").concat(e, ")");
      })
    }, m && {
      willChange: "transform"
    })
  }, p));
};

L.displayName = "Image";

var R,
    X,
    W,
    Y,
    B = o(s.img)(E || (E = i(["\n    width: auto;\n    max-width: 100%;\n    user-select: none;\n    touch-action: none;\n    ::selection {\n        background: none;\n    }\n"]))),
    H = function H(i) {
  var o = i.currentIndex,
      s = i.images,
      u = i.onClose,
      f = i.onNext,
      m = i.onPrev,
      g = i.renderImageOverlay,
      v = i.singleClickToZoom,
      h = r(!0),
      y = r(c(Array(s.length)).map(function () {
    return e.createRef();
  }) || []),
      b = function () {
    var e = n({
      height: window.innerHeight,
      width: window.innerWidth
    }),
        r = l(e, 2),
        i = r[0],
        o = r[1];
    return t(function () {
      var e = function e() {
        window.innerHeight === i.height && window.innerWidth === i.width || o({
          height: window.innerHeight,
          width: window.innerWidth
        });
      };

      return window.addEventListener("resize", e), window.addEventListener("orientationchange", e), function () {
        window.removeEventListener("resize", e), window.addEventListener("orientationchange", e);
      };
    }), i;
  }(),
      w = b.height,
      O = b.width,
      x = n(!1),
      C = l(x, 2),
      P = C[0],
      E = C[1],
      k = n("100%"),
      D = l(k, 2),
      T = D[0],
      j = D[1],
      I = n(!1),
      N = l(I, 2),
      R = N[0],
      X = N[1],
      W = e.useCallback(function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
        r = (e - o) * O + (t ? n : 0);
    return e < o - 1 || e > o + 1 ? {
      display: "none",
      x: r
    } : {
      display: "flex",
      x: r
    };
  }, [o, O]),
      Y = p(s.length, function (e) {
    return W(e);
  }),
      B = l(Y, 2),
      H = B[0],
      A = B[1];

  t(function () {
    var e = null == y ? void 0 : y.current[o],
        t = 0;
    e && null != e && e.current && (t = e.current.clientHeight - 50), T !== t && j(t);
  }, [o, T, w]), t(function () {
    h.current ? h.current = !1 : A.start(function (e) {
      return W(e);
    });
  }, [o, W, A]);
  var S = d({
    onDrag: function onDrag(e) {
      var t = e.down,
          n = l(e.movement, 1)[0],
          r = l(e.direction, 1)[0],
          i = e.velocity,
          o = e.distance,
          a = e.cancel,
          c = e.active,
          s = e.touches,
          u = e.tap;

      if (!P && 0 !== n && !u) {
        R || X(!0);
        var p = Math.abs(r) > .7;

        if ((t && p && o > O / 3.5 || t && p && i > 2) && c) {
          var g = r > 0 ? -1 : 1;
          return a(), void (g > 0 ? f() : g < 0 && m());
        }

        s > 1 ? a() : A.start(function (e) {
          return W(e, t, n);
        });
      }
    },
    onDragEnd: function onDragEnd() {
      R && (A.start(function (e) {
        return W(e);
      }), setTimeout(function () {
        return X(!1);
      }, 100));
    },
    onWheel: function onWheel(e) {
      var t = e.velocity,
          n = l(e.direction, 2),
          r = n[0],
          i = n[1];

      if (!e.ctrlKey && !P && 0 !== t && (R || X(!0), t > 1.1)) {
        var o = r + i > 0 ? -1 : 1;
        o > 0 ? f() : o < 0 && m();
      }
    },
    onWheelEnd: function onWheelEnd() {
      A.start(function (e) {
        return W(e);
      }), setTimeout(function () {
        return X(!1);
      }, 100);
    }
  }, {
    drag: {
      filterTaps: !0
    }
  });
  return e.createElement(e.Fragment, null, H.map(function (t, n) {
    var r = t.display,
        i = t.x;
    return e.createElement(U, a({}, S(), {
      className: "lightbox-image-pager",
      key: n,
      onClick: function onClick() {
        return Math.abs(i.get()) < 1 && !P && u();
      },
      ref: y.current[n],
      role: "presentation",
      style: {
        display: r,
        transform: i.to(function (e) {
          return "translateX(".concat(e, "px)");
        })
      }
    }), e.createElement(z, null, e.createElement(Z, null, e.createElement(F, {
      onClick: function onClick(e) {
        e.stopPropagation(), e.nativeEvent.stopImmediatePropagation();
      }
    }, e.createElement(L, {
      imgProps: s[n],
      isCurrentImage: n === o,
      pagerHeight: T,
      pagerIsDragging: R,
      setDisableDrag: E,
      singleClickToZoom: v
    }), g()))));
  }));
};

H.displayName = "ImagePager";

var A,
    S,
    Z = o.div(R || (R = i(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"]))),
    z = o.div(X || (X = i(["\n    width: 100%;\n    display: flex;\n    justify-content: center;\n"]))),
    U = o(s.div)(W || (W = i(["\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    height: 100%;\n    width: 100%;\n    will-change: transform;\n    touch-action: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n"]))),
    F = o.div(Y || (Y = i(["\n    position: relative;\n    touch-action: none;\n    user-select: none;\n"]))),
    M = function M(t) {
  var n = t.currentIndex,
      r = t.images,
      i = t.onClose,
      o = t.onNext,
      a = t.onPrev,
      l = t.renderImageOverlay,
      c = t.renderNextButton,
      s = t.renderPrevButton,
      u = t.singleClickToZoom,
      f = n > 0,
      p = n + 1 < r.length;
  return e.createElement(K, {
    className: "lightbox-image-stage",
    "data-testid": "lightbox-image-stage"
  }, s({
    canPrev: f
  }), e.createElement(H, {
    currentIndex: n,
    images: r,
    onClose: i,
    onNext: o,
    onPrev: a,
    renderImageOverlay: l,
    singleClickToZoom: u
  }), c({
    canNext: p
  }));
},
    K = o.div(A || (A = i(["\n    flex-grow: 1;\n    position: relative;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"])));

function q(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function G(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? q(Object(n), !0).forEach(function (t) {
      v(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : q(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var J = function J(t) {
  var n = t.children,
      r = t.className,
      i = t.isOpen,
      o = t.pageTransitionConfig,
      a = t.style,
      l = {
    config: G(G({}, m.default), {}, {
      friction: 32,
      mass: 1,
      tension: 320
    }),
    enter: {
      opacity: 1,
      transform: "scale(1)"
    },
    from: {
      opacity: 0,
      transform: "scale(0.75)"
    },
    leave: {
      opacity: 0,
      transform: "scale(0.75)"
    }
  },
      c = g(i, G(G({}, l), o));
  return e.createElement(e.Fragment, null, c(function (t, i) {
    return i && e.createElement(Q, {
      className: "lightbox-container".concat(r ? " ".concat(r) : ""),
      "data-testid": "lightbox-container",
      style: G(G({}, t), a)
    }, n);
  }));
},
    Q = o(s.div)(S || (S = i(["\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    z-index: 400;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n"])));

function V(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = C(e);

    if (t) {
      var i = C(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);

    return x(this, n);
  };
}

var $ = function (e) {
  O(n, e);
  var t = V(n);

  function n() {
    var e;
    y(this, n);

    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
      i[o] = arguments[o];
    }

    return e = t.call.apply(t, [this].concat(i)), v(w(e), "portalContainer", void 0), v(w(e), "body", void 0), v(w(e), "preventWheel", function (e) {
      return e.preventDefault();
    }), e;
  }

  return b(n, [{
    key: "componentDidMount",
    value: function value() {
      this.body = document.body, this.portalContainer = document.createElement("div"), this.portalContainer.setAttribute("class", "lightbox-portal"), this.body.appendChild(this.portalContainer), this.forceUpdate(), this.portalContainer.addEventListener("wheel", this.preventWheel);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.portalContainer.removeEventListener("wheel", this.preventWheel), this.body.removeChild(this.portalContainer);
    }
  }, {
    key: "render",
    value: function value() {
      if (void 0 === this.portalContainer) return null;
      var e = this.props.children;
      return P.createPortal(e, this.portalContainer);
    }
  }]), n;
}(e.Component);

export default function (n) {
  var r = n.isOpen,
      i = n.onClose,
      o = n.images,
      a = void 0 === o ? [] : o,
      l = n.currentIndex,
      c = n.onPrev,
      s = n.onNext,
      u = n.renderHeader,
      f = void 0 === u ? function () {
    return null;
  } : u,
      p = n.renderFooter,
      m = void 0 === p ? function () {
    return null;
  } : p,
      g = n.renderPrevButton,
      d = void 0 === g ? function () {
    return null;
  } : g,
      v = n.renderNextButton,
      h = void 0 === v ? function () {
    return null;
  } : v,
      y = n.renderImageOverlay,
      b = void 0 === y ? function () {
    return null;
  } : y,
      w = n.className,
      O = void 0 === w ? "" : w,
      x = n.singleClickToZoom,
      C = void 0 !== x && x,
      P = n.style,
      E = void 0 === P ? {} : P,
      k = n.pageTransitionConfig,
      D = void 0 === k ? null : k;
  return t(function () {
    var e = function e(_e) {
      r && ["ArrowUp", "ArrowDown", "End", "Home", "PageUp", "PageDown"].includes(_e.key) && _e.preventDefault();
    },
        t = function t(e) {
      if (r) switch (e.key) {
        case "ArrowLeft":
          c();
          break;

        case "ArrowRight":
          s();
          break;

        case "Escape":
          i();
          break;

        default:
          e.preventDefault();
      }
    };

    return document.addEventListener("keyup", t), document.addEventListener("keydown", e), function () {
      document.removeEventListener("keyup", t), document.removeEventListener("keydown", e);
    };
  }), e.createElement($, null, e.createElement(J, {
    className: O,
    isOpen: r,
    pageTransitionConfig: D,
    style: E
  }, f(), e.createElement(M, {
    currentIndex: l,
    images: a,
    onClose: i,
    onNext: s,
    onPrev: c,
    renderImageOverlay: b,
    renderNextButton: h,
    renderPrevButton: d,
    singleClickToZoom: C
  }), m()));
}